const leafTemplate = require('./leaf');
const artisanTemplate = require('./artisan');

module.exports = [leafTemplate, artisanTemplate];
